import { createSelector } from 'reselect';

export const selectOverlay = state => state.overlay;

export const selectIsOverlayOpen = createSelector(
  selectOverlay,
  overlay => !!overlay.show,
);

export const selectOverlayType = createSelector(
  selectOverlay,
  overlay => overlay.type,
);

export const selectOverlayOptions = createSelector(
  selectOverlay,
  overlay => overlay.options,
);

export const selectOverlayReturnFocusTo = createSelector(
  selectOverlay,
  overlay => overlay.returnFocusTo,
);
